import React from 'react';
import { Mail, MapPin, Github, Linkedin, Heart, ArrowRight, ChevronRight } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../images/logo-insiightdraft.png';

function Footer() {
    const navigate = useNavigate();
    const location = useLocation();

    const footerStyles = `
        .footer {
            background-color: #101010;
            border-top: 1px solid rgba(6, 182, 212, 0.15);
            padding: 3rem 0 1.5rem;
            margin-top: auto;
        }

        .footer-logo {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;
        }

        .footer-logo img {
            height: 36px;
            width: auto;
        }

        .footer-logo span {
            margin-left: 10px;
            font-size: 1.3rem;
            font-weight: 800;
            background: linear-gradient(90deg, #125ed1ff, #06b6d4);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        .footer-description {
            color: #aaa;
            font-size: 0.95rem;
            line-height: 1.7;
            margin-bottom: 1.5rem;
        }

        .footer-heading {
            color: #0e4aa5ff;
            font-weight: 700;
            font-size: 1.1rem;
            margin-bottom: 1.2rem;
            position: relative;
        }

        .footer-heading::after {
            content: '';
            position: absolute;
            bottom: -6px;
            left: 0;
            width: 40px;
            height: 3px;
            background: linear-gradient(90deg, #06b6d4, #a855f7);
            border-radius: 3px;
        }

        .footer-links {
            list-style: none;
            padding: 0;
            margin: 0;
        }

        .footer-links li {
            margin-bottom: 0.8rem;
        }

        .footer-links a {
            color: #aaa;
            text-decoration: none;
            font-size: 0.95rem;
            transition: all 0.3s ease;
            display: inline-flex;
            align-items: center;
            gap: 6px;
        }

        .footer-links a:hover {
            color: #06b6d4;
            transform: translateX(5px);
        }

        .footer-links a svg {
            opacity: 0;
            transition: opacity 0.3s ease;
            width: 14px;
            height: 14px;
        }

        .footer-links a:hover svg {
            opacity: 1;
        }

        .contact-item {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 1rem;
            color: #aaa;
            font-size: 0.95rem;
        }

        .contact-icon1 {
            width: 36px;
            height: 36px;
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(6, 182, 212, 0.1));
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgb(215, 216, 219);
            transition: all 0.3s ease;
        }

        .contact-item:hover .contact-icon1 {
            background-color: #0b44c8;
            color: white;
        }

        .contact-item a {
            color: #aaa;
            text-decoration: none;
            transition: color 0.3s ease;
        }

        .contact-item a:hover {
            color: #06b6d4;
        }

        .social-links {
            display: flex;
            gap: 12px;
            margin-top: 1.5rem;
        }

        .social-icon {
            width: 40px;
            height: 40px;
            background: rgba(99, 102, 241, 0.08);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgb(214, 215, 216) !important;
            transition: all 0.3s ease;
            border: 1px solid rgba(183, 184, 184, 0.15);
            text-decoration: none;
        }

        .social-icon:hover {
            background-color: #0a65de;
            box-shadow: 0 8px 20px rgba(99, 102, 241, 0.25);
            border-color: transparent;
        }

        .github:hover {
            background-color: #060606;
            color: white;
            box-shadow: 0 8px 20px rgba(99, 102, 241, 0.25);
            border-color: transparent;
        }

        .footer-bottom {
            margin-top: 2.5rem;
            padding-top: 1.5rem;
            border-top: 1px solid rgba(6, 182, 212, 0.15);
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
        }

        .copyright {
            color: #888;
            font-size: 0.9rem;
        }

        .made-with {
            display: flex;
            align-items: center;
            gap: 5px;
            color: #888;
            font-size: 0.9rem;
        }

        .heart-icon {
            color: #ef4444;
            animation: heartbeat 1.5s ease-in-out infinite;
        }

        @keyframes heartbeat {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.15); }
        }

        .footer-cta {
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(6, 182, 212, 0.08));
            border-radius: 16px;
            padding: 1.5rem;
            margin-bottom: 2rem;
            border: 1px solid rgba(6, 182, 212, 0.15);
        }

        .footer-cta h4 {
            color: #0e4aa5ff;
            font-weight: 700;
            margin-bottom: 0.5rem;
        }

        .footer-cta p {
            color: #aaa;
            font-size: 0.95rem;
            margin-bottom: 1rem;
        }

        .cta-button {
            background: linear-gradient(135deg, #0e4aa5ff, #06b6d4);
            color: white;
            border: none;
            border-radius: 30px;
            padding: 10px 24px;
            font-weight: 600;
            font-size: 0.95rem;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s ease;
            cursor: pointer;
        }

        .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(6, 182, 212, 0.3);
            color: white;
        }

        /* Mobile Responsive Styles */
        @media (max-width: 768px) {
            .footer {
                padding: 2rem 0 1rem;
            }

            .footer-heading {
                margin-top: 1.5rem;
            }

            .social-icon{
                background-color: #124be8 !important;
                color: white !important;
            }

            .github{
                background-color: #060606 !important;
            }

            /* Hide underline on mobile */
            .footer-heading::after {
                display: none;
            }

            /* Center align all columns on mobile */
            .footer .row > [class*="col-"] {
                text-align: center;
            }

            /* Center Quick Links, Services, Legal items */
            .footer-links {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .footer-links li {
                text-align: center;
            }

            .footer-links a {
                justify-content: center;
            }

            /* Center Get in Touch content */
            .contact-item {
                justify-content: center;
            }

            /* Center social links */
            .social-links {
                justify-content: center;
            }

            /* Center brand column content */
            .footer-logo {
                justify-content: center;
            }

            .footer-description {
                text-align: center;
            }

            .footer-bottom {
                flex-direction: column;
                text-align: center;
                gap: 1rem;
            }

            .footer-cta {
                text-align: center;
            }
        }

        @media (max-width: 576px) {
            .footer-logo span {
                font-size: 1.1rem;
            }

            .footer-logo img {
                height: 30px;
            }

            /* Stack grid on very small screens */
            .footer .row {
                flex-direction: column;
                align-items: center;
            }

            .footer .col-12 {
                width: 100%;
                max-width: 300px;
                margin-left: auto;
                margin-right: auto;
            }
        }
    `;

    const handleSmoothScroll = (e, targetId) => {
        e.preventDefault();
        
        if (location.pathname !== '/') {
            navigate('/', { state: { scrollTo: targetId } });
            return;
        }
        
        setTimeout(() => {
            const element = document.getElementById(targetId);
            if (element) {
                const navbarHeight = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    };

    const currentYear = new Date().getFullYear();

    return (
        <>
            <style>{footerStyles}</style>
            <footer className="footer">
                <div className="container">
                    {/* CTA Section */}
                    <div className="footer-cta">
                        <div className="row align-items-center">
                            <div className="col-12 col-md-8">
                                <h4>Ready to Build Your Business?</h4>
                                <p className="mb-md-0">
                                    Get AI-powered insights and launch your idea today.
                                </p>
                            </div>
                            <div className="col-12 col-md-4 text-md-end">
                                <button 
                                    className="cta-button"
                                    onClick={() => navigate('/new')}
                                >
                                    Start Free Analysis <ArrowRight size={18} />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Main Footer Content */}
                    <div className="row">
                        {/* Brand Column */}
                        <div className="col-12 col-lg-3 col-md-6 mb-4 mb-lg-0">
                            <div className="footer-logo">
                                <img src={logo} alt="InsightDraft AI Logo" />
                                <span>InsightDraft AI</span>
                            </div>
                            <p className="footer-description">
                                Turn any idea into a real business with AI-powered strategies, 
                                market analysis, and launch insights in minutes.
                            </p>
                            <div className="social-links">
                                <a 
                                    href="https://www.linkedin.com/in/aman-rajput-2b7680316/"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="social-icon"
                                >
                                    <Linkedin size={20} />
                                </a>
                                <a 
                                    href="https://github.com/rajput81325"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="social-icon github"
                                >
                                    <Github size={20} />
                                </a>
                            </div>
                        </div>

                        {/* Quick Links Column */}
                        <div className="col-6 col-lg-2 col-md-6 mb-4 mb-lg-0">
                            <h5 className="footer-heading">Quick Links</h5>
                            <ul className="footer-links">
                                <li>
                                    <a href="/">
                                        <ChevronRight size={14} /> Home
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#how-to-use"
                                        onClick={(e) => handleSmoothScroll(e, 'how-to-use')}
                                    >
                                        <ChevronRight size={14} /> How to Use
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#about"
                                        onClick={(e) => handleSmoothScroll(e, 'about')}
                                    >
                                        <ChevronRight size={14} /> About
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#contact"
                                        onClick={(e) => handleSmoothScroll(e, 'contact')}
                                    >
                                        <ChevronRight size={14} /> Contact
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Services Column */}
                        <div className="col-6 col-lg-2 col-md-6 mb-4 mb-lg-0">
                            <h5 className="footer-heading">Services</h5>
                            <ul className="footer-links">
                                <li>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/new');
                                        }}
                                    >
                                        <ChevronRight size={14} /> New Business Idea
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/existing');
                                        }}
                                    >
                                        <ChevronRight size={14} /> Existing Business
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Legal Column - NEW */}
                        <div className="col-6 col-lg-2 col-md-6 mb-4 mb-lg-0">
                            <h5 className="footer-heading">Legal</h5>
                            <ul className="footer-links">
                                <li>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/privacy-policy');
                                        }}
                                    >
                                        <ChevronRight size={14} /> Privacy Policy
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/terms-and-conditions');
                                        }}
                                    >
                                        <ChevronRight size={14} /> Terms & Conditions
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/terms-of-service');
                                        }}
                                    >
                                        <ChevronRight size={14} /> Terms of Service
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('/cookie-policy');
                                        }}
                                    >
                                        <ChevronRight size={14} /> Cookie Policy
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Contact Column */}
                        <div className="col-12 col-lg-3 col-md-6 mb-4 mb-lg-0">
                            <h5 className="footer-heading">Get in Touch</h5>
                            <div className="contact-item">
                                <div className="contact-icon1">
                                    <Mail size={18} />
                                </div>
                                <a href="mailto:c84289798@gmail.com">
                                    c84289798@gmail.com
                                </a>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon1">
                                    <MapPin size={18} />
                                </div>
                                <span>Ahmedabad, India</span>
                            </div>
                        </div>
                    </div>

                    {/* Footer Bottom */}
                    <div className="footer-bottom">
                        <div className="copyright">
                            © {currentYear} InsightDraft AI. All rights reserved.
                        </div>
                        <div className="made-with">
                            Made with <Heart size={16} className="heart-icon" /> for entrepreneurs
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;